import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as trans from '../FrontMessages';
import { ROUTE_SIGN_IN,ROUTE_SIGN_UP,ROUTE_COMPLETE_PROFILE,RouteChanged } from '../RouteConstents';

const PhoneOTP = () => {

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors },setValue } = useForm();
    const [phone, setPhone] = useState('');
    const [load, setLoad] = useState(0);

    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(60);

    const [otpFirst, setOtpFirst] = useState('');
    const [otpTwo, setOtpTwo] = useState('');
    const [otpThree, setOtpThree] = useState('');
    const [otpFour, setOtpFour] = useState('');



    const { string } = useParams();
    
    useEffect(
        () => {
        document.body.classList.add('login-page');

        checkPhoneLink();

        const interval = setInterval(() => {
            if (seconds > 0) {
              setSeconds(seconds - 1);
            }
        
            if (seconds === 0) {
              if (minutes === 0) {
                clearInterval(interval);
              } else {
                setSeconds(59);
                setMinutes(minutes - 1);
              }
            }
        }, 1000);
    
        return () => {
            clearInterval(interval);
        };

    },[seconds]); 


    const handleChange = (e) => {
        const { maxLength, value, name } = e.target;
        const [fieldName, fieldIndex] = name.split("-");
      
        let fieldIntIndex = parseInt(fieldIndex, 10);
      
        // Check if no of char in field == maxlength
        if (value.length >= maxLength) {
      
          // It should not be last input field
          if (fieldIntIndex < 3) {
      
            // Get the next input field using it's name
            const nextfield = document.querySelector(
              `input[name=field-${fieldIntIndex + 1}]`
            );
      
            // If found, focus the next field
            if (nextfield !== null) {
              nextfield.focus();
            }
          }
        }
    }
       
    
    const checkPhoneLink = async () => {
        let objValue =  {"method_name":"checkPhoneExist","phone_id":string}
        if(load === 0) {
            setLoad(1)
            await axios.post(API_URL,objValue).then(function (response) {
                if (response.status === RESPONSE_SUCCESS) {
                    
                    if(response.data.status === "error") {
                        toast.error(response.data.message); 
                        navigate(ROUTE_SIGN_UP);
                    } else {
                        setValue("phone", response.data.phoneInfo.phone)
                        setPhone(response.data.phoneInfo.phone)
                    }
                } else {
                    toast.error(response.data.errors.errors[0].msg);
                }
    
            }).catch(function (error) {
                toast.error(error.message);
            });
        } 
    };

    const reSendOTP = async () => {
        
        let objValue =  {"method_name":"userResendOtp","phone_id":string,"phone":phone}

        await axios.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 
                    
                    setMinutes(0);
                    setSeconds(60);
                    
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
        
    };


    const onSubmit = async (data) => {
        
        let otpFirstVal  = data.otpFirst.trim();
        let otpTwoVal = data.otpTwo.trim();
        let otpThreeVal = data.otpThree.trim();
        let otpFourVal = data.otpFour.trim();

        let phoneOtp = otpFirstVal+otpTwoVal+otpThreeVal+otpFourVal;

        phoneOtp = phoneOtp.trim();

        let objValue = {"method_name":"verifyUserPhone","phone_id":string,"phone":phone,phone_otp:phoneOtp};
        await axios.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 
                    navigate(); 
                    navigate(RouteChanged(ROUTE_COMPLETE_PROFILE,response.data.phone_id));
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
    }

    return (
        <div style={{ backgroundColor: '#00BCD4' }}>
            
            <div className="login-box">
                <div className="logo">
                    <img src="/assets/images/logo.png" alt="SBS" width="100" />
                </div>
                <div className="card ">
                    <div className="body phone_otp">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <br/>
                            <div className="input-group">
                                <div className="form-line">
                                    
                                    <input 
                                        type="text" 
                                        className="form-control text-center" 
                                        name="phone"    
                                        placeholder="Phone" 
                                        onChange={(e) => setPhone(e.target.value)}
                                        readOnly={true}
                                        {...register("phone",{ 
                                            required: false,
                                                 
                                        })}
                                    />
                                    
                                </div>
                            </div>

                            
                            <div className="inputfield">
                                <input 
                                    type="text" 
                                    maxLength="1" 
                                    className="input"
                                    onChange={(e) => setOtpFirst(e.target.value)}
                                    {...register("otpFirst",{ 
                                        required: false,
                                    })}    
                                />

                                <input 
                                    type="text" 
                                    maxLength="1" 
                                    className="input"  
                                    onChange={(e) => setOtpTwo(e.target.value)}
                                    {...register("otpTwo",{ 
                                        required: false,
                                    })}    
                                />

                                <input 
                                    type="text" 
                                    maxLength="1" 
                                    className="input"  
                                    onChange={(e) => setOtpThree(e.target.value)}
                                    {...register("otpThree",{ 
                                        required: false,
                                    })}     
                                />    

                                <input 
                                    type="text" 
                                    maxLength="1" 
                                    className="input"  
                                    onChange={(e) => setOtpFour(e.target.value)}
                                    {...register("otpFour",{ 
                                        required: false,
                                    })}    
                                />        

                                
                            </div>
                            <br/>
                            <div className="text-left text-danger">
                            {seconds > 0 || minutes > 0 ? (
                                <p>
                                OTP expiring in {minutes < 10 ? `0${minutes}` : minutes}:
                                {seconds < 10 ? `0${seconds}` : seconds}
                                </p>
                            ) : (
                                <p>Didn't receive code? <span className="text-info" role="button" onClick={reSendOTP}>Click here</span></p>
                            )}       
                            </div>
                            <br/>
                            <div className="row">
                                <div className="col-xs-12 text-center">
                                    <button className="btn bg-pink waves-effect" type="submit">Verify Phone</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="footer_login">
                <p><Link to={ROUTE_SIGN_IN}>Sign In</Link></p>
            </div>
        </div>
    );
   
}
    
export default PhoneOTP;